/**
 * NavigationBlock class handles the functionality of the navigation block.
 * This is the main navigation on both desktop and mobile and its unique to KFAB.
 */
class NavigationBlock {
	/**
	 * Constructor initializes the necessary DOM elements and adds event listeners.
	 */
	constructor() {
		/**
		 * Menu toggle buttons.
		 *
		 * @type {NodeList}
		 */
		this.menuToggleButtons = document.querySelectorAll(
			'.wp-block-navigation__container > .wp-block-page-list > .wp-block-navigation-item.has-child > .wp-block-navigation-submenu__toggle'
		);

		/**
		 * Sub-menu toggle buttons.
		 *
		 * @type {NodeList}
		 */
		this.subMenuToggleButtons = document.querySelectorAll(
			'.wp-block-navigation__submenu-container > .wp-block-navigation-item.has-child > .wp-block-navigation-submenu__toggle'
		);

		/**
		 * Ancestor page toggle buttons.
		 *
		 * @type {NodeList}
		 */
		this.currentPageAncestorToggleButtons = document.querySelectorAll(
			'.wp-block-pages-list__item.current-menu-ancestor > .wp-block-navigation__submenu-icon'
		);

		/**
		 * Current page toggle buttons.
		 *
		 * @type {NodeList}
		 */
		this.currentPageToggleButtons = document.querySelectorAll(
			'.wp-block-pages-list__item.current-menu-item > .wp-block-navigation__submenu-icon'
		);

		/**
		 * Overlay buttons.
		 *
		 * @type {NodeList}
		 */
		this.overlayButtons = document.querySelectorAll( '.mobile-toggle-btn' );

		/**
		 * Navigation block container.
		 *
		 * @type {HTMLElement}
		 */
		this.navigationBlockContainer = document.querySelector(
			'.wp-block-navigation__responsive-container'
		);

		/**
		 * Navigation block container dialog.
		 *
		 * @type {HTMLElement}
		 */
		this.navigationBlockContainerDialog = this.navigationBlockContainer?.querySelector(
			'.wp-block-navigation__responsive-dialog'
		);

		/**
		 * Navigation block close buttons.
		 *
		 * @type {NodeList}
		 */
		this.navigationBlockCloseButtons = document.querySelectorAll(
			'.mobile-toggle-btn-close'
		);

		/**
		 * AC Nav Collapse element.
		 *
		 * @type {HTMLElement}
		 */
		this.acNavCollapse = document.querySelector( '.ac-nav-collapse' );

		/**
		 * Site header element.
		 *
		 * @type {HTMLElement}
		 */
		this.siteHeader = document.querySelector( '.site-header' );

		this.init();
	}

	/**
	 * Initializes the event listeners.
	 */
	init() {
		this.menuToggleButtons?.forEach( this.handleMenuToggleClick );
		this.subMenuToggleButtons?.forEach( this.handleSubMenuToggleClick );
		this.currentPageAncestorToggleButtons?.forEach( this.openSubmenus );
		this.currentPageToggleButtons?.forEach( this.openSubmenus );
	}

	/**
	 * Handles the click event on menu toggle buttons.
	 *
	 * @param {HTMLElement} menuToggleButton - The clicked menu toggle button.
	 */
	handleMenuToggleClick = menuToggleButton => {
		menuToggleButton.addEventListener( 'click', () => {
			menuToggleButton.toggleAttribute( 'data-expanded' );
		} );
	};

	/**
	 * Handles the click event on sub-menu toggle buttons.
	 *
	 * @param {HTMLElement} subMenuToggleButton - The clicked sub-menu toggle button.
	 */
	handleSubMenuToggleClick = subMenuToggleButton => {
		subMenuToggleButton.addEventListener( 'click', () => {
			subMenuToggleButton.toggleAttribute( 'data-expanded' );
		} );
	};

	/**
	 * Handles the click event on sub-menu toggle buttons.
	 *
	 * @param {HTMLElement} subMenuToggleButton - The clicked sub-menu toggle button.
	 */
	openSubmenus = subMenuToggleButton => {
		subMenuToggleButton.toggleAttribute( 'data-expanded' );
	};

	/**
	 * Handles the click event on overlay buttons.
	 *
	 * @param {HTMLElement} overlayButton - The clicked overlay button.
	 */
	handleOverlayClick = overlayButton => {
		overlayButton.addEventListener( 'click', () => {
			this.openMobileMenu();
		} );
	};

	/**
	 * Handles the click event on close buttons.
	 *
	 * @param {HTMLElement} closeButton - The clicked close button.
	 */
	handleCloseClick = closeButton => {
		closeButton.addEventListener( 'click', () => {
			this.closeMobileMenu();
		} );
	};

	/**
	 * Removes 'data-expanded' attribute from other buttons except the current one.
	 *
	 * @param {HTMLElement} currentButton - The current button.
	 * @param {NodeList}    buttons       - The buttons to remove 'data-expanded' from.
	 */
	removeExpandedFromOthers = ( currentButton, buttons ) => {
		buttons.forEach( button => {
			if ( button !== currentButton && button.hasAttribute( 'data-expanded' ) ) {
				button.removeAttribute( 'data-expanded' );
			}
		} );
	};
}

// Usage
new NavigationBlock();
